export var WebhooksEventPatterns;
(function (WebhooksEventPatterns) {
    WebhooksEventPatterns["WEBHOOKS_ERROR"] = "WEBHOOKS_ERROR";
})(WebhooksEventPatterns || (WebhooksEventPatterns = {}));
//# sourceMappingURL=webhooks-event-patterns.enum.js.map